import { Injectable, Output, EventEmitter, Directive } from '@angular/core';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class ChangeSideBarTooltipLanguage {

  @Output() changeTooltipLang: EventEmitter<any> = new EventEmitter();

  constructor() {}

  

  emitChangeLang() {
    this.changeTooltipLang.emit();
  }

  
}
